<template>
    <div :class="phoneClass || 'index-container'" style="background: #F7F9FA">
        <app-header>
            <div class="side-bar" slot="center">
                <template v-for="path in sideBarList">
                    <div 
                        v-if="isShow(path)"
                        class="side-bar-block"
                        :class="{active: path.path === $route.path || ($route.path === '/device/gateway'&& path.path === '/device')}"
                        :key="path.path"
                        @click="$router.push(path.path)"
                        :ref="path.path.substr(1)">
                        <template v-if="phoneClass">
                            <img v-if="path.path === $route.path" class="side-bar-icon" :src="require('../assets/img/phoneSideBar'+path.path+'-active.png')" >
                            <img v-else class="side-bar-icon" :src="require('../assets/img/phoneSideBar'+path.path+'.png')" >
                        </template>
                        <img v-else class="side-bar-icon" :src="require('../assets/img/sideBar'+path.path+'.png')" >
                        <p>{{ $t('sideBar.' + path.path.slice(1))}}</p>
                        <div v-if="path.path === '/user' && userNewCount>0"
                            class="remind">
                            {{userNewCount}}
                        </div>
                    </div>
                </template>
            </div>
        </app-header>
        <div class="content-wrapper">
            <app-content></app-content>
        </div>
    </div>
</template>
<script>
import Core from 'core/core'
import AppHeader from './layout/header'
import AppContent from './layout/content'
import {refresh} from "core/winSize"
export default {
    data() {
        return {
            user: Core.Data.getUser() ? Core.Data.getUser() : '',
            sideBarList: [],
	        phoneClass: '',
	        userNewCount: '',
	        newSetInterval: '',
        };
    },
    created(){
	    console.log (this.user)
	    refresh(this,'phoneClass-index-container');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-index-container');
		    },10)
	    };
	    this.initUserNewCount()
	    this.newSetInterval = setInterval(()=>{
		    this.initUserNewCount()
	    },5000)
    },
    components:{
        AppHeader,
        AppContent
    },
    mounted() {
        this.initSideBar();
    },
    beforeDestroy(){
        clearInterval(this.newSetInterval)
    },
    computed: {
    },
    methods: {
        isShow(path) {
            if (this.phoneClass) {
                return this.setPhoneDisplay(path.path, this.user.role || 1)
                // return path.phoneShow && (path.path !== '/help' ? true : this.user.role === 100 || this.user.role === 101 || this.user.role === 102 ? true : false)
            }
            return path.path !== '/help' ? true : this.user.role === 100 || this.user.role === 101 || this.user.role === 102 ? true : false
        },
	    initUserNewCount(){
		    Core.Api.User.countNewApply().then((res)=>{
			    // console.log (res,'newUserApply')
			    this.userNewCount = res.response
		    }).catch(err => {
                console.log('initUserNewCount error:', err)
            })
	    },
        initSideBar() {
            let user = Core.Data.getUser()
            let arr =  this.$router.options.routes;
            this.sideBarList = [];
            arr.forEach(path => {
                let storageFlag = user.role === 1
                if(path.public) {
                    if(path.path === '/storage') {
                        if (!storageFlag) {
                            this.sideBarList.push(path)
                        }
                    } else if (path.path === '/distribution'){
                        if (storageFlag) {
                            this.sideBarList.push(path)
                        }
                    } else {
                        this.sideBarList.push(path)
                    }
                }
            });
	        console.log ('SideBar', this.sideBarList)
        },
        setPhoneDisplay(path, role) {
            let auth = {
                1: ['/home', '/device', '/dealer', '/user', '/distribution'], // 超管
                2: ['/storage', '/setting'], // 工厂
                // 1: ['/home', '/device', '/dealer', '/user'], // 超管
                // 2: ['/setting'], // 工厂
                10: ['/home', '/setting'], // 服务商
                100: ['/home', '/device', '/authority', '/setting', '/help'], // 客户
                101: ['/home', '/device', '/authority', '/setting', '/help'], // 组长
                102: ['/home', '/device', '/authority', '/setting', '/help'], // 组员
            }
            return auth[role].indexOf(path) !== -1;
        },
        setDisplayNone(ref) {
            try {
                let dom = this.$refs[ref] ? this.$refs[ref][0] : ''
                if (dom) {
                    dom.style.display= 'none'
                }
            } catch (e) {
                console.error(ref, 'e', e);
            }
        },
    },
    updated(){
        //   1 超级管理员   2 丽尔达   10服务商    100Fm管理员   101组长   102
        let user = Core.Data.getUser()
        if (user.role === 1) {
            this.setDisplayNone('authority')
        } else if (user.role === 2){
            this.setDisplayNone('home')
            this.setDisplayNone('device')
            this.setDisplayNone('dealer')
            this.setDisplayNone('user')
            this.setDisplayNone('log')
            this.setDisplayNone('authority')
        } else if (user.role === 10){
            //除了数据全部隐藏
            // this.$refs.home[0].style.display= 'none'
            this.setDisplayNone('device')
            this.setDisplayNone('dealer')
            this.setDisplayNone('user')
            this.setDisplayNone('log')
            this.setDisplayNone('authority')
            this.setDisplayNone('storage')
            // this.$refs.setting[0].style.display= 'none'

        } else if (user.role === 100 || user.role === 101 || user.role === 102){
                this.$refs.user ? this.$refs.user[0].style.display= 'none' : '';
                this.$refs.dealer ? this.$refs.dealer[0].style.display= 'none' : '';
                this.$refs.storage ? this.$refs.storage[0].style.display= 'none' : '';
        }
    }
};
</script>

<style scoped lang="scss">
// web端样式
.index-container{
    background: #E5EBEF;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-width: 1240px;
    font-size: 0;
    .side-bar {
        display: inline-block;
        height: 100%;
        // margin-left: 140px;
        .side-bar-block {
            width: 100px;
            text-align: center;
            padding-top: 16px;
            height: 100%;
            display: inline-block;
            cursor: pointer;
            position: relative;
            &.active {
                // opacity: 0.3;
                background-image: linear-gradient(-180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.30) 99%);
            }
            .side-bar-icon {
                width: 30px;
                height: 30px;
                display: inline-block;
                &.icon-home {
                    background: url("../assets/img/sideBar/home.png") no-repeat center;
                    background-size: 100% 100%;
                }
                &.icon-device {
                    background: url("../assets/img/sideBar/device.png") no-repeat center;
                    background-size: 100% 100%;
                }
                &.icon-dealer {
                    background: url("../assets/img/sideBar/dealer.png") no-repeat center;
                    background-size: 100% 100%;
                }
                &.icon-user {
                    background: url("../assets/img/sideBar/user.png") no-repeat center;
                    background-size: 100% 100%;
                }
                &.icon-log {
                    background: url("../assets/img/sideBar/log.png") no-repeat center;
                    background-size: 100% 100%;
                }
                &.icon-authority {
                    background: url("../assets/img/sideBar/authority.png") no-repeat center;
                    background-size: 100% 100%;
                }
                &.icon-store {
                    background: url("../assets/img/sideBar/storage.png") no-repeat center;
                    background-size: 100% 100%;
                }
                &.icon-setting {
                    background: url("../assets/img/sideBar/setting.png") no-repeat center;
                    background-size: 100% 100%;
                }
            }
            p {
                margin-top: 8px;
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
            }
            .remind {
                width: 20px;
                height: 20px;
                font-weight: 600;
                border-radius: 50%;
                position: absolute;
                top: 10px;
                right: 10px;
                color: white;
                background: red;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
    .content-wrapper{
        display: flex;
        background: #E5EBEF;
    }
}
</style>

<style lang="scss">
// 移动端样式
.phoneClass-index-container {
    .header-wrapper {
        //height: 147px;
        align-items: baseline;

        .header-left{
            align-items: baseline;
        }
        .header-right {
            >* {
                display: inline-block;
            }
            .user-avatar-wrapper{
                vertical-align: middle;
                .user-avatar {
                    img {
                        width: 30px;
                    }
                    span {
                        font-size: 16px;
                        vertical-align: super;
                        color: white;
                    }
                }
            }
        }
        .side-bar{
            display: flex;
            justify-content: space-around;
            align-items: center;
            background: white;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            color: #A1A3A5;
            z-index: 100;
            border-top: 1px solid #CDCDCD;
            .side-bar-block {
                margin: 0;
                p {
                    font-size: 10px;
                }
            }
            .active {
                //background: #0A3D95;
                color: #0F58D6;
            }
            .remind {
                width: 15px !important;
                font-size: 10px !important;
                height: 15px !important;
                line-height: 15px !important;
                top: 3px !important;
                right: 5px !important;
                text-align: center !important;
                font-weight: 600;
                border-radius: 50%;
                position: absolute;
                color: white;
                background: red;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            >* {
                padding: 7px 0;
                display: inline-block;
                position: relative;
                text-align: center;
                width: 20%;
                img {

                    width: 17px;
                }
                div {
                    text-align: center;
                }
            }
        }
    }
}
</style>
